export default __webpack_public_path__ + "images/SummerHelpBackground.web.png";